<template>
    <div class="practiveitem2-container">
        <div class="practive-toptitle">
            <p>幼儿照护保育</p>
            <span>综合实训数字资源系统（PC版）</span>
        </div>
        <p class="practive-subtitle">以0-3岁幼儿照护职业技能等级对应的工作领域、工作任务及职业技能要求为基础，对幼儿照护所涉及的日常生活照料、安全防护、卫生保健、早期发展指导、环境创设等专业内容进行虚拟仿真实训。</p>
        <div class="practive-pics">
            <img :src="require('@/assets/images/index/item13.png')" alt="">
            <img :src="require('@/assets/images/index/item14.png')" alt="">
        </div>
        <p class="pics-tips">用户界面</p>
        <div class="banquan">© 2021 文泉幼教. 版权所有. 幼儿照护保育综合实训数字资源系统.</div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            
        }
    },
    created() {},
    mounted() {},
    methods: {
        
    }
}
</script>
<style lang='scss' scoped>
.practiveitem2-container {
    .practive-toptitle {
        height: 72px;
        background: linear-gradient(90deg, #0A56B1 0%, #607FFF 100%);
        border-radius: 8px;
        width: 100%;
        color: #fff;
        padding: 9px 30px;
        box-sizing: border-box;
        &>p {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }
        &>span {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }
    }
    .practive-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        padding: 30px 26px;
        box-sizing: border-box;
    }
    .practive-pics {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        &>img {
            width: 420px;
        }
    }
    .pics-tips {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin: 15px 0 0;
        text-align: center;
    }
    .pics3 {
        width: 500px;
        text-align: center;
        display: block;
        margin: auto;
    }
    .banquan {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        height: 60px;
        background: #F7F7F7;
        border-radius: 8px;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-top: 40px;
        margin-bottom: 80px;
    }
}
</style>